import React, { useEffect, useId, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { makeKey, formatChemicalFormulas } from "../utilities";
import infoIcon from "../../images/icons/info.svg";
const SideBarRadioButtons = ({ multiRadioButtonsConfig, chosenCategory, chosenValue, pageType, }) => {
    const [sidebarTitles, setSidebarTitles] = useState({
        title: "",
        subtitle: "",
        tooltip: { title: true, sub: true },
    });
    // TODO to consider getting the title and subtitle also from the backend
    useEffect(() => {
        switch (pageType) {
            case "environmental_indicators_data":
                setSidebarTitles({
                    title: "Emisja\nzanieczyszczeń",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            case "economic_zite_data":
                setSidebarTitles({
                    title: "Dane ZITE",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            case "economic_pite_data":
                setSidebarTitles({
                    title: "Dane PITE",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            case "social_data":
                setSidebarTitles({
                    title: "Ubóstwo energetyczne",
                    subtitle: undefined,
                    tooltip: { title: true, sub: false },
                });
                break;
            default:
                break;
        }
    }, [pageType]);
    const TooltipSocial = (React.createElement(Tooltip, null, "Ub\u00F3stwo energetyczne - wyst\u0119puje wtedy, gdy gospodarstwo domowe nie jest w stanie zapewni\u0107 sobie wystarczaj\u0105cego poziomu ciep\u0142a, ch\u0142odu, o\u015Bwietlania i energii do zasilania urz\u0105dze\u0144 w wyniku po\u0142\u0105czenia niskich dochod\u00F3w, wysokich wydatk\u00F3w energetycznych i niskiej efektywno\u015Bci energetycznej budynku (GUS)."));
    const TooltipEnvironmental = (React.createElement(Tooltip, null, formatChemicalFormulas("Emisja zanieczyszczeń jest to wprowadzenie do środowiska (w tym przypadku do atmosfery) zanieczyszczeń. Uwolnione zanieczyszczenia są transportowane w atmosferze co przekłada się na zmianę ich stężenia oraz koszty środowiskowe. W portalu określono wskaźniki oraz afekty środowiskowe zanieczyszczeń pyłowych (PM10, PM2.5), gazów cieplarnianych (CH4, CO2) oraz innych zanieczyszczeń bezpośrednio wpływających na zdrowie ludzkie (SO2, NOx).")));
    const TooltipPITE = (React.createElement(Tooltip, null, "Polski Indeks Transformacji Energetycznej (PITE) stanowi wariant Zmodyfikowanego Indeksu Transformacji Energetycznej (ZITE), kt\u00F3ry r\u00F3wnie\u017C opiera si\u0119 na zaawansowanej metodologii statystycznej rekomendowanej przez OECD oraz Wsp\u00F3lne Centrum Badawcze (JRC) Komisji Europejskiej pozwalaj\u0105cej ograniczy\u0107 wp\u0142yw subiektywnych decyzji na konstrukcj\u0119 wska\u017Anika kompozytowego, ale w odr\u00F3\u017Cnieniu od ZITE jego warto\u015B\u0107 jest wyznaczana wy\u0142\u0105cznie na podstawie analizy szereg\u00F3w czasowych dotycz\u0105cych polskiej gospodarki. W ten spos\u00F3b warto\u015Bci PITE w pe\u0142ni koresponduj\u0105 do reali\u00F3w polskiej energetyki i nie s\u0105 zniekszta\u0142cane przez zjawiska i procesy wyst\u0119puj\u0105ce w innych regionach \u015Bwiata."));
    const TooltipZITE = (React.createElement(Tooltip, null, "Zmodyfikowany Indeks Transformacji Energetycznej (ZITE) stanowi ulepszon\u0105 wersj\u0119 indeksu ETI publikowanego przez \u015Awiatowe Forum Ekonomiczne. ZITE opiera si\u0119 na zaawansowanej metodologii statystycznej rekomendowanej przez OECD oraz Wsp\u00F3lne Centrum Badawcze (JRC) Komisji Europejskiej, co pozwala ograniczy\u0107 wp\u0142yw subiektywnych decyzji na konstrukcj\u0119 wska\u017Anika kompozytowego."));
    const getTooltipForTitle = () => {
        switch (pageType) {
            case "social_data":
                return TooltipSocial;
            case "environmental_indicators_data":
                return TooltipEnvironmental;
            case "economic_pite_data":
                return TooltipPITE;
            case "economic_zite_data":
                return TooltipZITE;
            default:
                return TooltipSocial;
        }
    };
    return (React.createElement("section", { className: "radioSidebar" },
        React.createElement("div", { className: "card mb-4" },
            React.createElement("div", { className: "card-body" },
                React.createElement("h1", { className: "fs-4 fw-bold mb-0 d-flex justify-content-between align-items-center", style: { whiteSpace: "pre-line" } },
                    sidebarTitles.title,
                    sidebarTitles.tooltip.title && (React.createElement(OverlayTrigger, { placement: "right", overlay: getTooltipForTitle() },
                        React.createElement("img", { src: infoIcon, alt: "Ikona informacji", className: "ms-1" })))))),
        sidebarTitles.subtitle !== undefined && (React.createElement("div", { className: "card mb-4" },
            React.createElement("div", { className: "card-body" },
                React.createElement("h6", { className: "mb-0" },
                    sidebarTitles.subtitle,
                    " ",
                    sidebarTitles.tooltip.sub && (React.createElement(OverlayTrigger, { placement: "right", overlay: TooltipSocial },
                        React.createElement("img", { src: infoIcon, alt: "Ikona informacji", className: "ms-1" }))))))),
        multiRadioButtonsConfig.map((group) => {
            return (React.createElement("div", { key: group.categoryId, className: "card mb-4" },
                React.createElement("div", { className: "card-header" },
                    React.createElement("h5", { className: "mb-0" }, group.category)),
                React.createElement("div", { className: "card-body" }, group.values.map((value) => {
                    const uniqueID = useId();
                    const handleClick = () => {
                        if (!value.disabled && value.callback !== undefined) {
                            value.callback(group.category, group.categoryId, value.value, value.id);
                        }
                    };
                    return (React.createElement("div", { key: makeKey(), className: "form-check mb-2 clickable", onClick: handleClick },
                        React.createElement("input", { disabled: value.disabled, type: "radio", id: value.id + uniqueID, name: "left-menu", value: value.id, onChange: handleClick, checked: chosenCategory.chosenCategoryId === group.categoryId &&
                                chosenValue.chosenValueId === value.id, className: "form-check-input clickable" }),
                        React.createElement("label", { htmlFor: value.id + uniqueID, className: "form-check-label clickable" }, formatChemicalFormulas(value.value))));
                }))));
        })));
};
export default SideBarRadioButtons;
